import { z } from 'zod';

export const chatPublicActivityEntrySchema = z.object({
  id: z.string().min(1),
  kind: z.literal('status'),
  label: z.string().trim().min(1),
  at: z.string().datetime(),
  triggerMessageId: z.number().int().positive(),
});

export type ChatPublicActivityEntry = z.infer<typeof chatPublicActivityEntrySchema>;

export const MANAGED_CHAT_PROGRESS = {
  review: { phase: 'managed-review', active: 'Reviewing how to answer…', done: 'Reviewed how to answer' },
  query: { phase: 'managed-query', active: 'Querying your data…', done: 'Ran a query' },
  retry: {
    phase: 'managed-query',
    active: 'Adjusting the query and running it again…',
    done: 'Adjusted the query and ran it again',
  },
  table: { phase: 'managed-table', active: 'Building a table…', done: 'Built a table' },
  step: { phase: 'managed-step', active: 'Working on your request…', done: 'Completed a step' },
} as const;

const managedStatusPhases = new Map<string, string>(
  Object.values(MANAGED_CHAT_PROGRESS).flatMap(({ phase, active, done }): [string, string][] => [
    [active, phase],
    [done, phase],
  ])
);
export function getManagedChatStatusPhase(label: string): string | undefined {
  return managedStatusPhases.get(label);
}
